import React from "react";
import { useWatchState } from "@/store";
import { Modal } from "antd";
import "./style.less";

const style = {
    textIndent: "2em"
}

const App = () => {

    const [[{ title = "云课堂介绍", show, hide, width = 700 }]] = useWatchState(["modal.forum"])

    return (
        <Modal
            title={title}
            visible={show}
            width={width}
            maskClosable={false}
            onCancel={hide}
            footer={false}
        >
            <div className="child-top-sm">
                <p style={style}>一，培训定位：聚焦目标地区目标产业;聚焦产业共性技术人才技能培养。</p>

                <p style={style}>二，培训组织：天合平台与地区政府部门合作;天合组织相关专业机构合办。</p>

                <p style={style}>三，培训课程：针对地区产业共性技术需求;组织设置系列专业技术课程。</p>

                <p style={style}>四，培训方法：线上讲课与线下授课结合;专家集中授课与导师定向辅导结合。</p>

                <p style={style}>五，培训教程：每期培训10-15学时;每期设置5-8门系列技术课程。</p>

                <p style={style}>六，培训对象：目标产业的企业选送学员;地区政府部门出资支持培训。</p>

                <p style={style}>七，培训要求：学员受企业推荐，注册登记;学员保证全程参加培训;学员经学院结业考试合格;学院领导委员会联合颁发结业证书。</p>
            </div>
        </Modal>
    );
}

export default App;